import { useEffect } from 'react';
import config from "../config/config.ts";
import { Product } from "@common/enums/Product.ts";
import { ProductIdentifier } from "@common/utils/identifyProduct.ts";

const identifier : ProductIdentifier = new ProductIdentifier(config.productOverride as Product);

export const MetadataUpdater = () => {
    useEffect(() => {
        const currentProduct = identifier.getProductFromHost(window.location.hostname);
        if (currentProduct == null) return;
        document.title = currentProduct.displayName;

        const iconLink = document.querySelector('link[rel="icon"]');
        if (iconLink) {
            iconLink.setAttribute('href', currentProduct.icon);
        }
    }, []);

    return null;
};